import Querschnitt from './Querschnitt'

export default class Material{
    /**
     * Klasse für Materialien
     * @param {Materialliste} list 
     * @param {Number} emodul E-modul des Materials
     * @param {Number} wichte Materialspezifische Dichte
     * @param {String} name Name des Materials
     */
    constructor(list, emodul, wichte, name){
        this.name = name || 'neues Material'
        this.Emodul = emodul || 0
        this.Wichte = wichte || 0
        this.Querschnittliste = []
        this.list = list || null
    }
    get number() {
        if(this.list) return this.list.indexOf(this)+1
        else return null
    }
    add_Querschnittverknüpfung(querschnitt){this.Querschnittliste.push(querschnitt)}
    delete_Querschnittverknüpfung(querschnitt){
        if (this.Querschnittliste.indexOf(querschnitt)==-1) return console.log('Querschnitt nicht in Liste')
        this.Querschnittliste.splice(this.Querschnittliste.indexOf(querschnitt),1)}
}
